import { trackForkIsClicked } from './bigQuery/logoMakerForkIsClicked';
import { trackForkIsShown } from './bigQuery/logoMakerForkIsShown';

const bigQuery = {
    trackForkIsClicked,
    trackForkIsShown,
};

export { bigQuery };
